import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import {oneOf} from 'shared/store';

class Rule extends DomainObject {
  ruleType;
  parameters = [];

  _relations = {
    type: oneOf(['direct_report', 'employee', 'location', 'department', 'employment_type', 'all_employees'])
  };

  constructor(other) {
    super();

    makeObservable(this, {
      ruleType: observable,
      parameters: observable
    });

    this.merge(other);
  }
}

export default Rule;
